import { FC } from 'react';

import { SFFooterViewModel } from '@api/index';
import { Facebook, Insta, Twitter, Youtube } from '@assets/icons';

import { SocialMediaContainer, SocialMediaLink } from './styled';

const getTypeIcon = (type: string) => {
  switch (type) {
    case 'facebook':
      return <Facebook />;
    case 'instagram':
      return <Insta />;
    case 'twitter':
      return <Twitter />;
    case 'youtube':
      return <Youtube />;
  }
};
export type socialMediaIconsType = Pick<SFFooterViewModel, 'footerIcons'>;

const SocialMediaIcons: FC<socialMediaIconsType> = ({ footerIcons }) => {
  if (
    !footerIcons ||
    (Array.isArray(footerIcons) && footerIcons?.length === 0)
  ) {
    return null;
  }

  return (
    <SocialMediaContainer>
      {footerIcons?.map((t) => (
        <SocialMediaLink
          key={t?.type}
          title={t?.type?.toString()?.toLocaleUpperCase()}
          href={t?.href}
        >
          {getTypeIcon(t.type as string)}
        </SocialMediaLink>
      ))}
    </SocialMediaContainer>
  );
};
export default SocialMediaIcons;
